
import {
    Pressable,
    Image,
    View
} from "react-native";
import {
    type AvatarProps
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    getFirstAndLastWord
} from "../../utils";

const Avatar = ({
    imageStyle,
    imageURL,
    onPress,
    style,
    name,
    size
}: AvatarProps) => {
    const {
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext();

    const avatarText = () => {
        const {
            first,
            last
        } = getFirstAndLastWord(name || "");

        if (first && last) {
            return `${first[0]}${last[0]}`;
        }
        if (first) {
            return `${first[0]}`;
        }
        return "";
    };

    const renderNoImage = () => {
        return <View
            style={{
                ...stylesheet.noImageContainer,
                height: size ? size : "auto",
                width: size ? size : "auto"
            }}
        >
            <Text
                allowFontScaling={false}
                variant="titleMediumSize"
                style={
                    {
                        color: colors.content.container.primary
                    }
                }
            >
                {avatarText().toUpperCase()}
            </Text>
        </View>;
    };

    const renderProfilePhoto = () => {
        if (imageURL) {
            return <Image
                source={{
                    uri: imageURL
                }}
                style={[
                    {
                        height: size ? size : "auto",
                        width: size ? size : "auto",
                        borderWidth: borders.line
                    },
                    imageStyle
                ]}
            />;
        } else {
            return renderNoImage();
        }
    };

    return <Pressable
        onPress={() => {
            if (onPress) {
                onPress();
            }
        }}
        style={[
            stylesheet.container,
            {
                backgroundColor: colors.content.container.primary,
                borderRadius: radiuses.lg,
                height: size,
                width: size
            },
            style
        ]}
    >
        {renderProfilePhoto()}
    </Pressable>;
};
export default Avatar;
